<template>
  <div class="emails emails-input">
    <div v-for="user in users" :key="user.id" class="email-chip user-chip" :class="{'invalid': isInvalid}">
      <UserVignette :user="user" :enable-link="false" />
      <a href="#" class="remove" @click="() => onRemove(user)" v-if="onRemove">×</a>
    </div>
  </div>
</template>
<script>
import UserVignette from '../../user/UserVignette'

export default {
  name: 'UserChipList',
  components: { UserVignette },
  props: {
    users: {
      type: Array,
      required: true
    },
    isInvalid: {
      type: Boolean,
      required: false
    },
    onRemove: {
      type: Function,
      default: null
    }
  }
}
</script>
<style scoped lang="scss">

.config-container {
  margin: 20px;
  padding-bottom: 50px;
}

.emails.emails-input .email-chip.user-chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.625rem 0 0;
}

.user-chip > :first-child {
  margin: 0;
}

.button-remove {
  margin-left: 32px;
}

h3 {
  margin-top: 1.5em
}
</style>
